module.exports = __webpack_public_path__ + "static/img/6.6e4b24e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/zh/6.png
// module id = Q5aG
// module chunks = 0